import {useAppDispatch, useAppSelector} from '../../../../redux/hooks';
import {RootState} from '../../../../redux/store';
import {TextEditor} from '../../../../Atoms/TextEditor';
import {
    addNewItem,
    addNewSpell,
    changeItem,
    changeSpell,
    removeItem, removeSpell
} from '../../../../redux/slices/character/characterSlice';
import Input from '../../../../Atoms/Input';
import Button from '../../../../Atoms/Button';
import {DeleteOutlineSharp, Label} from '@mui/icons-material';
import {DropDown} from '../../../../Atoms/DropDown';
import {useQuery} from '@apollo/client';
import {GetAbilities, GetSpellListTypes} from '../../../../GraphQL/CharacterQueries';
import React, {useEffect} from 'react';
import {
    getCantripsForCharacter,
    getMaxSpellLevel4Character, getMaxSpellAmount4Character,
} from '../../../../Helper/helperFunctions';
import {setIsAppLoading} from "../../../../redux/slices/content/contentSlice";
import {toast} from "react-toastify";
import {DropdownEntry} from "../../../../Helper/Constants";
import { SelectChangeEvent } from "@mui/material";
import {Spell} from "../../../../redux/slices/character/characterType";

export const KampagneSpellbook = () => {
    const spells = useAppSelector((state: RootState) => state.character.CharacterSheet.Spell);
    const dispatch = useAppDispatch();

    const [abilities, setAbilities] = React.useState<any[]>([]);
    const [spellListTypes, setSpellListTypes] = React.useState<DropdownEntry[]>([]);

    const {data: abilityData, loading: abilityLoading, error: abilityError} = useQuery(GetAbilities, {
        fetchPolicy: 'network-only'
    });

    const {data: spellListData, loading: spellListLoading, error: spellListError} = useQuery(GetSpellListTypes, {
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (spellListData && !spellListLoading) {
            const newDropDownList: DropdownEntry[] = [];
            newDropDownList.push({
                itemText: "Keine Spellliste ausgewählt",
                itemValue: 0
            });

            for (const spellListEntry of spellListData.getSpellListTypes) {
                newDropDownList.push({
                    itemText: spellListEntry.spellListTypeName,
                    itemValue: Number(spellListEntry.spellListTypeId)
                })
            }

            setSpellListTypes(newDropDownList);
        }
    }, [spellListData]);

    useEffect(() => {
        if (spellListError) {
            toast.error("Fehler beim Laden der Spelllisten Typen");
        }
    }, [spellListError]);

    useEffect(() => {
        if (abilityData && !abilityLoading) {
            const abilityList = [];
            abilityList.push({
                itemText: 'Noch kein Spielwert ausgewählt',
                itemValue: 0
            })
            for (const ability of abilityData.getAbilities) {
                abilityList.push({
                    itemText: ability.abilityName,
                    itemValue: ability.abilityId
                })
            }

            setAbilities(abilityList)
        }
    }, [abilityData])

    const setSavingThrow = (spell: any, abilityId: number) => {
        if (abilityId > 0) {
            const index = abilityData.getAbilities.findIndex((ability: any) => Number(ability.abilityId) === Number(abilityId));

            dispatch(changeSpell({
                ...spell,
                savingThrow: {
                    abilityName: abilityData.getAbilities[index].abilityName,
                    abilityId: abilityId
                },
            }))
        } else {
            dispatch(changeSpell({
                ...spell,
                savingThrow: {
                    abilityName: "",
                    abilityId: 0
                },
            }))
        }
    }

    const renderOneSpell = (spell: Spell, index: number) => {
        return (
            <div className='spellbook_single_spell_container' id={`spell-container-${index}`}>
                <div className='spellbook_single_spell_spellListType'>
                    <label>Aus der Spellliste: </label>
                    <DropDown className="spellType-dropdown" value={spell.spellListType !== null ? Number(spell.spellListType.spellListTypeId) : 0 }
                              setValue={(event: SelectChangeEvent) => {
                                   const listName = spellListData!.getSpellListTypes.find(spellList => Number(spellList.spellListTypeId) === Number(event.target.value));

                                    dispatch(changeSpell({
                                        ...spell,
                                        spellListType: {
                                            spellListTypeId: Number(event.target.value),
                                            spellListTypeName: listName !== undefined ? listName.spellListTypeName : "",
                                            Ability: {
                                                abilityId: listName !== undefined ? Number(listName.Ability.abilityId) : 0,
                                                abilityName: listName !== undefined ? listName.Ability.abilityName : "",
                                            }
                                        }
                                    }))
                                } }
                              items={ spellListTypes }  />
                </div>
                <div className='spellbook_single_spell_btn'>
                    <Button onClick={() => dispatch(removeSpell(spell.spellId))}><DeleteOutlineSharp/></Button>
                </div>
                <div className='spellbook_single_spell_name'>
                    <label>Name: </label>
                    <input value={spell.spellName}
                           onChange={(event) => dispatch(changeSpell({
                               ...spell,
                               spellName: event.target.value,
                           }))}/>
                </div>
                <div className='spellbook_single_spell_desc'>
                    <label>Beschreibung: </label>
                    <TextEditor className='inventory-editor' value={spell.spellText}
                                onChange={(value) => dispatch(changeSpell({
                                    ...spell,
                                    spellText: value,
                                }))}/>

                </div>
                <div className='spellbook_single_spell_con'>
                    <div className="con">
                        <label>Konzentration:</label>
                        <input type='checkbox' checked={spell.isConcentration} value={spell.isConcentration ? 1 : 0}
                               onChange={(event) => {
                                   dispatch(changeSpell({
                                       ...spell,
                                       isConcentration: !spell.isConcentration,
                                   }))
                               }}/>
                    </div>
                    <div className="active">
                        <label>Aktiv: </label>
                        <input type="checkbox" checked={spell.isActive} value={spell.isActive? 1 : 0} onChange={(event) => dispatch(changeSpell({
                            ...spell,
                            isActive: !spell.isActive
                        }))}/>
                    </div>
                </div>
                <div className='spellbook_single_spell_target_container'>
                    <div className='spellbook_single_spell_target_container_inner'>
                        <label>Ziele:</label>
                        <input value={spell.spellTarget}
                               onChange={(event) => dispatch(changeSpell({
                                   ...spell,
                                   spellTarget: event.target.value,
                               }))}/>
                    </div>
                    <div className='spellbook_single_spell_target_container_inner'>
                        <label>Dauer:</label>
                        <input className='number-input' value={spell.spellDuration}
                               onChange={(event) => dispatch(changeSpell({
                                   ...spell,
                                   spellDuration: event.target.value,
                               }))}/>
                    </div>
                    <div className='spellbook_single_spell_target_container_inner'>
                        <label>Kosten:</label>
                        <input className='number-input' type='number' value={spell.spellCost}
                               onChange={(event) => dispatch(changeSpell({
                                   ...spell,
                                   spellCost: Number(event.target.value),
                               }))}/>
                    </div>
                </div>
                <div className='spellbook_single_spell_target_container'>
                    <div className='spellbook_single_spell_target_container_inner'>
                        <label>Komponenten:</label>
                        <input value={spell.spellComponents}
                               onChange={(event) => dispatch(changeSpell({
                                   ...spell,
                                   spellComponents: event.target.value,
                               }))}/>
                    </div>
                    <div className='spellbook_single_spell_target_container_inner'>
                        <label>Typ:</label>
                        <input className='number-input' type='number' value={spell.spellType}
                               onChange={(event) => dispatch(changeSpell({
                                   ...spell,
                                   spellType: Number(event.target.value)
                               }))}/>
                    </div>
                    <div className='spellbook_single_spell_target_container_inner'>
                        <label>Rettungswurf:</label>
                        <DropDown className='number-input' value={spell.savingThrow.abilityId}
                                  setValue={(event) => setSavingThrow(spell, Number(event.target.value))}
                                  items={abilities}
                        />
                    </div>
                </div>
            </div>
        )
    }

    const renderAllSpells = () => {
        const html = [];
        let index = 0;
        for (const item of spells) {
            html.push(renderOneSpell(item, index))
            index++
        }

        return html
    }
    
    const newSpell = async () => {
        await dispatch(addNewSpell())
        const newSpell = document.getElementById(`spell-container-${spells.length}`)
        if (newSpell) {
            newSpell.scrollIntoView(true);
        }
    }

    return (
        <div className='spellbook_main'>
            <div className='spellbook_main_info'>
                <div className='character_spell_info'>
                    <div className='character_spell_info_inner'>
                        <div className=''>max. Anzahl an
                            Zaubertricks: { getCantripsForCharacter() }</div>
                        <div className=''>max. Anzahl an
                            Zauber: { getMaxSpellAmount4Character() }</div>
                        <div className=''>max.
                            Zauberlevel: { getMaxSpellLevel4Character() }</div>
                    </div>
                </div>
                <Button onClick={async () => await newSpell()}>Zauber hinzufügen</Button>
            </div>
            <div className='spellbook_spell_container'>
                {renderAllSpells()}
            </div>
        </div>
    )
}